import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("LoginWidget", {
  title: "Login",
});
